import { render, staticRenderFns, recyclableRender, components } from "./mix-upload-image.vue?vue&type=template&id=7522c5f8&"
var renderjs
import script from "./mix-upload-image.vue?vue&type=script&lang=js&"
export * from "./mix-upload-image.vue?vue&type=script&lang=js&"
import style0 from "./mix-upload-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/mix-upload-image/mix-upload-image.vue"
export default component.exports